//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { callApp, isApp, isWeiXin, system } from '../util/const'

export default {
  data () {
    return {
      isApp: Boolean(isApp()),
      isWeiXin: isWeiXin(),
      isIos: system(),
      openInBrowser: false
    }
  },
  methods: {
    call () {
      if (this.isWeiXin) {
        this.openInBrowser = true
        return
      }
      callApp('')
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/download.vue